module.exports = __webpack_public_path__ + "img/greatSatisfaction.4f691f70.png";